<template>
  <div
    class="card"
    v-show="currentCardId == 'ai_reason'"
    v-loading.fullscreen.lock="fullscreenLoading"
    :element-loading-text="loadingText"
  >
    <div class="container-base r-ai-format" v-if="!viewYagiprimepayment">
      <p class="r-midashi">ヤギプライム機能</p>
      <div class="title" v-if="!aiResultView">
        AIに自己PRと志望動機を書いてもらおう！
      </div>
      <div class="title" v-else>AIで自己PRと志望動機を提案</div>
      <div class="description" v-if="!aiResultView">
        <p>
          質問に答えるだけで、AIがあなたの自己PRと志望動機を作成してくれます。
        </p>
      </div>
      <div class="description" v-else>
        <p>AIから提案された文章をご活用ください。</p>
      </div>
      <div v-if="!aiResultView">
        <ul class="example-sentence">
          <li>
            <div class="title">※入力済みの履歴書内容</div>
            <div class="el-textarea">
              <div class="flex r-form-title">
                <span>最終学歴</span>
                <div class="el-textarea">
                  <el-input
                    type="textarea"
                    autosize
                    placeholder=""
                    autocomplete="off"
                    v-model="formatData.lastestEdu"
                  />
                </div>
              </div>
              <div class="flex r-form-title">
                <span>最終職歴</span>
                <div class="el-textarea">
                  <el-input
                    type="textarea"
                    autosize
                    placeholder=""
                    autocomplete="off"
                    v-model="formatData.lastestJob"
                  />
                </div>
              </div>
              <div class="flex r-form-title">
                <span>取得資格</span>
                <div class="el-textarea">{{ getLicences }}</div>
              </div>
            </div>
          </li>
          <li>
            <div class="title">Q.1 得意なこと</div>
            <div class="el-textarea">
              <el-input
                type="textarea"
                autosize
                placeholder="英語、プログラミング、コミュニケーション、Word など"
                autocomplete="off"
                v-model="formatData.ai_strength"
              />
            </div>
          </li>
          <li>
            <div class="title">Q.2 希望企業名</div>
            <div class="el-textarea">
              <el-input
                type="textarea"
                autosize
                placeholder="株式会社Yagish など"
                autocomplete="off"
                v-model="formatData.ai_company_name"
              />
            </div>
          </li>
          <li>
            <div class="title">Q.3 希望業界</div>
            <div class="el-textarea">
              <el-select
                v-model="formatData.hopeIndustrycategory"
                placeholder="選択してください"
                style="left: 0; max-width: 100%"
              >
                <el-option
                  v-for="item in hopeIndustryOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                />
              </el-select>
            </div>
          </li>
          <li>
            <div class="title">Q.4 希望職種</div>
            <div class="el-textarea">
              <el-select
                v-model="formatData.hopeJobcategory"
                placeholder="選択してください"
                style="left: 0; max-width: 100%"
              >
                <el-option
                  v-for="item in hopeJobcategoryOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                />
              </el-select>
            </div>
          </li>
        </ul>
        <div class="text-center r-btn-wrap">
          <el-button type="button" class="r-ai-btn" @click="getAIMypr"
            >この内容でAI自己PRを作成</el-button
          >
        </div>
      </div>
      <div v-else>
        <ul class="example-sentence">
          <li>
            <div class="title">AIから自己PRの提案</div>
            <div class="body" v-html="aiResultMyprResult"></div>
            <button class="r-use-result-btn" @click="useAiMyprResult">
              <span>この自己PRを使う</span>
            </button>
          </li>
          <li>
            <div class="title">AIから志望動機の提案</div>
            <div class="body" v-html="aiResultReasonResult"></div>
            <button class="r-use-result-btn" @click="useAiReasonResult">
              <span>この志望動機を使う</span>
            </button>
          </li>
        </ul>
        <div class="text-center r-btn-wrap" v-if="globalVar.isYagiPrime">
          <el-button
            type="button"
            class="r-ai-btn"
            @click="aiResultView = false"
            >再度取得する</el-button
          >
        </div>
        <div class="text-center r-btn-wrap" v-else>
          <el-button
            v-if="inAppPayments"
            type="button"
            class="r-ai-btn"
            @click="viewPaymentYagiprime"
            >ヤギプライムに加入して<br />文章全体を取得する</el-button
          >
        </div>
        <br />
        <div
          class="title"
          style="text-align: center"
          v-if="!globalVar.isYagiPrime"
        >
          AI履歴書はいかがでしたか？納得しなかった方はプロに見てもらいましょう！
        </div>
        <div class="text-center r-btn-wrap" v-if="!globalVar.isYagiPrime">
          <el-button
            v-if="inAppPayments"
            type="button"
            class="r-ai-btn"
            @click="viewPaymentYagiprime"
            >プロに相談する</el-button
          >
        </div>
      </div>
    </div>
    <div v-if="viewYagiprimepayment" class="ai-payment-card-box">
      <el-button
        type="success"
        id="prime-payment-btn"
        @click="skipAiContinueFree"
      >
        AI志望動機を利用せず、<br />無料で履歴書作成をつづける
        <i class="el-icon-d-arrow-right"></i>
      </el-button>
      <div class="container-base r-ai-format">
        <div class="overflow-scroll-y" v-if="!completeBuyYagiprime">
          <YagiprimeWrapper />
        </div>
        <div class="overflow-scroll-y" v-else>
          <div class="card-header">
            <h2>ヤギプライムに登録</h2>
            <p>登録完了しました。</p>
            <p style="color: red">※無料エージェント機能を使いますか？</p>
          </div>
          <div class="card-content" style="padding: 0">
            <div class="edit-form-item">
              <div class="card">
                <div class="overflow-scroll-y">
                  <div class="card-header">
                    <h2>担当エージェント会社の確認</h2>
                  </div>
                  <div class="card-content">
                    <div class="edit-form">
                      <div class="edit-form-item">
                        <div class="item-body" style="margin-left: 10px">
                          居住地：{{ basicData.address1 }}
                        </div>
                        <div class="item-body" style="margin-left: 10px">
                          希望職種：{{ formatData.hopeJobcategory }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="card-content">
                    <div class="edit-form" v-if="isMatching">
                      <div class="yp-agent-register">
                        <div class="card-header">
                          <h2 class="yp-h2">
                            もっとヤギプライムを活用するために
                          </h2>
                          <p>
                            特別に無料エージェント紹介を受けられます（Yagishと提携の会社による）。面接に進む等、最終的な判断はあなたに委ねられますのでご安心ください。
                          </p>
                        </div>
                        <div class="card-content">
                          <p>居住地：{{ basicData.address1 }}</p>
                          <p>希望職種：{{ formatData.hopeJobcategory }}</p>
                          <div class="yp-agent-list">
                            <div class="renew2_flex agent-info">
                              <img
                                v-if="matchingCompany.company_logo"
                                :src="matchingCompany.company_logo"
                                alt="該当エージェント"
                                class="agent-logo"
                              />
                              <div>
                                <p class="agent-txt">
                                  会社名：{{ matchingCompany.company_name }}
                                </p>
                                <p class="agent-txt">
                                  {{ matchingCompany.company_address1 }}
                                </p>
                              </div>
                            </div>
                            <p class="yp-agent-memo">
                              Yagishの<a href="/terms" target="_blank"
                                >利用規約</a
                              >、<a
                                href="https://www.yagish.jp/privacy/"
                                target="_blank"
                                >個人情報保護方針</a
                              >と {{ matchingCompany.company_name }}の<a
                                :href="matchingCompany.terms_url"
                                target="_blank"
                                >利用規約</a
                              >、<a
                                :href="matchingCompany.privacy_url"
                                target="_blank"
                                >個人情報保護方針</a
                              >を確認して{{
                                matchingCompany.company_name
                              }}に登録することになります。
                            </p>
                            <div class="flex consent-txt">
                              <img
                                src="/static/renew3_img/carat_img/caratcheck_icon.svg"
                                alt="チェック"
                                class="consent-icon"
                              />
                              <p>
                                {{
                                  matchingCompany.company_name
                                }}の利用規約に同意する
                              </p>
                            </div>
                          </div>
                          <div class="flex consent-txt">
                            <img
                              src="/static/renew3_img/carat_img/caratcheck_icon.svg"
                              alt="チェック"
                              class="consent-icon"
                            />
                            <p>Yagishの利用規約に同意する</p>
                          </div>
                          <div class="text-center r-btn-wrap">
                            <button
                              type="button"
                              class="el-button el-button--button r-ai-btn"
                              @click="applyAgent"
                            >
                              <span>無料エージェントを希望する</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="edit-form" v-else>
                      <div class="yp-agent-register">
                        <div class="card-content">
                          <p>居住地：{{ basicData.address1 }}</p>
                          <p>希望職種：{{ formatData.hopeJobcategory }}</p>
                          <div class="yp-agent-list">
                            <p class="yp-agent-lead">
                              該当するエージェントが見つかりませんでした。条件を変更すると良いエージェントが見つかるかも知れません。
                            </p>
                          </div>
                          <div class="flex consent-txt">
                            <img
                              src="/static/renew3_img/carat_img/caratcheck_icon.svg"
                              alt="チェック"
                              class="consent-icon"
                            />
                            <p>Yagishの利用規約に同意する</p>
                          </div>
                        </div>
                      </div>
                      <div class="edit-form-item">
                        <p style="color: red">
                          該当するエージェントが見つかりませんでした。条件を変更すると良いエージェントが見つかるかも知れません。
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-input
      type="textarea"
      v-model="formatData.reason"
      v-proofread
      :autosize="{ minRows: textareaMinRows, maxRows: 15 }"
    />
    <div class="attention-limit character" v-if="previewErrors.reason">
      <i class="el-icon-warning"></i>
      入力可能な文字数をオーバーしています。文章を短くするか、入力欄の大きい別の履歴書を選んでください。
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import YagiprimeWrapper from '@/components/Payment/YagiprimeWrapper.vue'
import { useRirekishoFormatData } from '@/composables/format-edit/useRirekishoFormatData'
import { useRirekishoAiReason } from '@/composables/format-edit/useRirekishoAiReason'
import hopeIndustryOptions from '@/utils/format-edit/rirekishoHopeIndustryOptions.json'
import hopeJobcategoryOptions from '@/utils/format-edit/rirekishoHopeJobcategoryOptions.json'
import type { BasicData } from '@/utils/format-edit/basicData'

const props = defineProps<{
  currentCardId?: string
  basicData: BasicData
  previewErrors: Record<string, string>
  textareaMinRows: number
  /** Ai career 用。指定時は生成前に useFeature ゲート */
  aiGateFeature?: string
}>()

const formatData = useRirekishoFormatData()
const {
  globalVar,
  fullscreenLoading,
  loadingText,
  aiResultView,
  aiResultMyprResult,
  aiResultReasonResult,
  viewYagiprimepayment,
  completeBuyYagiprime,
  matchingCompany,
  isMatching,
  getLicences,
  viewPaymentYagiprime,
  skipAiContinueFree,
  getAIMypr,
  applyAgent,
  useAiMyprResult,
  useAiReasonResult
} = useRirekishoAiReason(formatData, {
  gateFeature: props.aiGateFeature
})

const inAppPayments = computed(
  () => !!(globalVar as { in_app_payments?: boolean }).in_app_payments
)
</script>

<style lang="scss" scoped>
@import '@/assets/scss/format-edit/rirekisho-ai-reason';
</style>
